
// import React, { useEffect, useState } from "react";
// import axios from "../../api/axiosAuth";
// import { useAuth } from "../../context/AuthContext";
// import "../../style/HorasSocialesRector.css";

// export default function HorasSocialesEstudiante() {
//   const { token } = useAuth();

//   const [horas, setHoras] = useState([]);
//   const [asignacionId, setAsignacionId] = useState("");
//   const [horasValor, setHorasValor] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [submitting, setSubmitting] = useState(false);
//   const [error, setError] = useState(null);

//   /* =========================
//      🔹 CARGAR HORAS
//   ========================= */
//   const cargarHoras = async () => {
//     try {
//       setLoading(true);
//       setError(null);

//       const res = await axios.get("/horas-sociales/estudiante/actividades");

//       setHoras(Array.isArray(res.data?.horas) ? res.data.horas : []);
//     } catch (err) {
//       console.error("❌ cargarHoras:", err);
//       setError("No se pudieron cargar las horas sociales");
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* =========================
//      🔹 REGISTRAR HORAS
//   ========================= */
//   const registrarHoras = async () => {
//     if (!asignacionId || !horasValor) {
//       return alert("Seleccione actividad y horas realizadas");
//     }

//     if (Number(horasValor) <= 0) {
//       return alert("Las horas deben ser mayores a 0");
//     }

//     try {
//       setSubmitting(true);

//       await axios.post("/horas-sociales/estudiante/registrar", {
//         asignacion_id: asignacionId,
//         horas: Number(horasValor),
//       });

//       setAsignacionId("");
//       setHorasValor("");
//       await cargarHoras();

//     } catch (err) {
//       console.error("❌ registrarHoras:", err);
//       alert("Error registrando horas");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   useEffect(() => {
//     if (token) cargarHoras();
//   }, [token]);

//   return (
//     <div className="horas-container">
//       <h2 className="title">Horas Sociales</h2>

//       {/* ================= FORM ================= */}
//       <div className="card">
//         <h3>Registrar avance</h3>

//         <div className="form-grid">
//           <select
//             value={asignacionId}
//             onChange={(e) => setAsignacionId(e.target.value)}
//           >
//             <option value="">Seleccione actividad</option>
//             {horas.map((h) => (
//               <option key={h.id} value={h.id}>
//                 {h.actividad} ({h.estado})
//               </option>
//             ))}
//           </select>

//           <input
//             type="number"
//             min="1"
//             placeholder="Horas realizadas"
//             value={horasValor}
//             onChange={(e) => setHorasValor(e.target.value)}
//           />

//           <button
//             className="btn-primary"
//             onClick={registrarHoras}
//             disabled={submitting}
//           >
//             {submitting ? "Guardando..." : "Registrar"}
//           </button>
//         </div>
//       </div>

//       {/* ================= TABLA ================= */}
//       <div className="card">
//         <h3>Mis actividades</h3>

//         {loading ? (
//           <p className="loading">Cargando...</p>
//         ) : error ? (
//           <p className="error">{error}</p>
//         ) : (
//           <div className="table-container">
//             <table className="tabla-pro">
//               <thead>
//                 <tr>
//                   <th>Actividad</th>
//                   <th>Reportadas</th>
//                   <th>Aprobadas</th>
//                   <th>Estado</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {horas.length === 0 ? (
//                   <tr>
//                     <td colSpan="4" className="empty">
//                       No tienes actividades asignadas
//                     </td>
//                   </tr>
//                 ) : (
//                   horas.map((h) => (
//                     <tr key={h.id}>
//                       <td>{h.actividad}</td>
//                       <td>{h.horas_reportadas || 0}</td>
//                       <td>{h.horas_aprobadas || 0}</td>
//                       <td>
//                         <span className={`estado ${h.estado}`}>
//                           {h.estado}
//                         </span>
//                       </td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//             </table>
//           </div>
//         )}
//       </div>  
//     </div>
//   );
// }


//

import React, { useEffect, useState } from "react";
import axios from "../../api/axiosAuth";
import { useAuth } from "../../context/AuthContext";
import "../../style/HorasSocialesRector.css";

export default function HorasSocialesEstudiante() {
  const { token } = useAuth();

  const [horas, setHoras] = useState([]);
  const [resumen, setResumen] = useState({});
  const [estudiante, setEstudiante] = useState(null);

  const [asignacionId, setAsignacionId] = useState("");
  const [horasValor, setHorasValor] = useState("");

  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  /* =========================
     CARGAR INFORMACIÓN
  ========================= */

  const cargarHoras = async () => {
    try {
      setLoading(true);
      setError(null);

      const res = await axios.get(
        "/horas-sociales/estudiante/actividades"
      );

      setHoras(
        Array.isArray(res.data?.actividades)
          ? res.data.actividades
          : []
      );

      setResumen(res.data?.resumen || {});
      setEstudiante(res.data?.estudiante || null);

    } catch (err) {
      console.error(err);
      setError("No fue posible cargar la información.");
    } finally {
      setLoading(false);
    }
  };

  /* =========================
     REGISTRAR HORAS
  ========================= */

  const registrarHoras = async () => {

    if (!asignacionId)
      return alert("Seleccione una actividad.");

    if (!horasValor || Number(horasValor) <= 0)
      return alert("Ingrese una cantidad válida.");

    try {

      setSubmitting(true);

      await axios.post(
        "/horas-sociales/estudiante/registrar",
        {
          asignacion_id: asignacionId,
          horas: Number(horasValor)
        }
      );

      setAsignacionId("");
      setHorasValor("");

      await cargarHoras();

      alert("Horas registradas correctamente.");

    } catch (err) {

      console.error(err);

      alert(
        err.response?.data?.message ||
        "Error registrando horas."
      );

    } finally {

      setSubmitting(false);

    }
  };

  useEffect(() => {

    if (token) {

      cargarHoras();

    }

  }, [token]);

  return (
    <div className="horas-container">

      <h2 className="title">
        Mis Horas Sociales
      </h2>

      {estudiante && (
        <div className="card">

          <h3>
            {estudiante.nombre}
          </h3>

          <p>

            <strong>Grado:</strong>{" "}
            {estudiante.grado}

            {" - "}

            <strong>Grupo:</strong>{" "}
            {estudiante.grupo}

          </p>

        </div>
      )}

      {/* =====================
          RESUMEN
      ====================== */}

      <div className="cards-resumen">

        <div className="mini-card">
          <h4>Horas asignadas</h4>
          <span>
            {resumen.horas_asignadas || 0}
          </span>
        </div>

        <div className="mini-card">
          <h4>Reportadas</h4>
          <span>
            {resumen.horas_reportadas || 0}
          </span>
        </div>

        <div className="mini-card">
          <h4>Aprobadas</h4>
          <span>
            {resumen.horas_aprobadas || 0}
          </span>
        </div>

        <div className="mini-card">
          <h4>Pendientes</h4>
          <span>
            {resumen.horas_pendientes || 0}
          </span>
        </div>

      </div>

      <div className="card">

        <h3>
          Avance General
        </h3>

        <div className="progress">

          <div
            className="progress-bar"
            style={{
              width: `${resumen.porcentaje || 0}%`
            }}
          />

        </div>

        <p
          style={{
            marginTop: 10,
            fontWeight: 600
          }}
        >
          {resumen.porcentaje || 0} %
          completado
        </p>

      </div>

      {/* =====================
          REGISTRAR
      ====================== */}

      <div className="card">

        <h3>
          Registrar Horas
        </h3>

        <div className="form-grid">

          <select
            value={asignacionId}
            onChange={(e) =>
              setAsignacionId(e.target.value)
            }
          >

            <option value="">
              Seleccione actividad
            </option>

            {horas
              .filter(
                h => h.estado !== "aprobado"
              )
              .map((h) => (

                <option
                  key={h.id}
                  value={h.id}
                >
                  {h.actividad}
                </option>

              ))}

          </select>

          <input
            type="number"
            min="1"
            value={horasValor}
            placeholder="Horas realizadas"
            onChange={(e) =>
              setHorasValor(e.target.value)
            }
          />

          <button
            className="btn-primary"
            onClick={registrarHoras}
            disabled={submitting}
          >

            {submitting
              ? "Guardando..."
              : "Registrar"}

          </button>

        </div>

      </div>

      {/* =====================
          TABLA
      ====================== */}

      <div className="card">

        <h3>
          Mis Actividades
        </h3>

        {loading ? (

          <p>Cargando...</p>

        ) : error ? (

          <p className="error">
            {error}
          </p>

        ) : (

          <div className="table-container">

            <table className="tabla-pro">

              <thead>

                <tr>

                  <th>Actividad</th>

                  <th>Máximo</th>

                  <th>Reportadas</th>

                  <th>Aprobadas</th>

                  <th>Pendientes</th>

                  <th>Estado</th>

                </tr>

              </thead>

              <tbody>

                {horas.length === 0 ? (

                  <tr>

                    <td
                      colSpan="6"
                      className="empty"
                    >

                      No tienes actividades asignadas

                    </td>

                  </tr>

                ) : (

                  horas.map((h) => (

                    <tr key={h.id}>

                      <td>{h.actividad}</td>

                      <td>
                        {h.horas_maximas}
                      </td>

                      <td>
                        {h.horas_reportadas}
                      </td>

                      <td>
                        {h.horas_aprobadas}
                      </td>

                      <td>
                        {h.horas_pendientes}
                      </td>

                      <td>

                        <span
                          className={`estado ${h.estado}`}
                        >
                          {h.estado}
                        </span>

                      </td>

                    </tr>

                  ))

                )}

              </tbody>

            </table>

          </div>

        )}

      </div>

    </div>
  );
}